import css from './imageViewer.module.scss';

import { memo, ReactEventHandler, useEffect, useState } from 'react';

import Preloader from 'core/ui/Preloader';

type Props = {
  url: string;
  closeModal: () => void;
};

function ImageViewer({ url, closeModal }: Props) {
  const [sizes, setSizes] = useState<
    { [K in 'width' | 'height']: number } | null
  >(null);

  const onLoad: ReactEventHandler<HTMLImageElement> = event => {
    const img$ = event.target as HTMLImageElement;
    setSizes({ width: img$.naturalWidth, height: img$.naturalHeight });
  };

  useCloseOnEscape(closeModal);

  return (
    <div className={css.root} onClick={closeModal}>
      {!sizes && <Preloader className={css.preloader} />}
      <img
        src={url}
        style={
          sizes
            ? { maxWidth: sizes.width + 'px', maxHeight: sizes.height + 'px' }
            : { display: 'none' }
        }
        className={css.image}
        onLoad={onLoad}
        crossOrigin="use-credentials"
      />
    </div>
  );
}

export default memo(ImageViewer);

// A hacky way to avoid keybind race condition between closing multiple modals
// at once. ImageViewer won't have any sub-modals so we can safely override
// all other keybinds when it's shown.
function useCloseOnEscape(closeModal: () => void) {
  useEffect(() => {
    const onKeyUp = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeModal();
        event.stopPropagation();
        event.preventDefault();
      }
    };

    document.body.addEventListener('keyup', onKeyUp, { capture: true });
    return () =>
      document.body.removeEventListener('keyup', onKeyUp, { capture: true });
  }, []);
}
